import { render, staticRenderFns } from "./RedundantTerms.vue?vue&type=template&id=107827f0&scoped=true&"
import script from "./RedundantTerms.vue?vue&type=script&lang=ts&"
export * from "./RedundantTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107827f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
